// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3g7eQ","colCheckbox":"styles_colCheckbox__2Bw96"};